import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"25px"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_float_button = _resolveComponent("a-float-button")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_a_float_button, { key: 0 }, {
          icon: _withCtx(() => [
            _createVNode(_component_a_spin, { style: {"margin-top":"5px"} })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_a_button, { onClick: _ctx.reader }, {
      default: _withCtx(() => [
        _createTextVNode("QRコードを読む")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_a_button, { onClick: _ctx.bulkView }, {
      default: _withCtx(() => [
        _createTextVNode("一括削除")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_a_table, {
      columns: _ctx.columns,
      "data-source": _ctx.data
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.dataIndex==='operation')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.isAuthority)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: ($event: any) => (_ctx.edit(record))
                  }, "編集", 8, _hoisted_1))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    onClick: ($event: any) => (_ctx.edit(record)),
                    disabled: ""
                  }, "編集", 8, _hoisted_2))
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns", "data-source"]),
    _createElementVNode("div", null, [
      _createVNode(_component_a_modal, {
        title: "編集",
        open: _ctx.visible,
        footer: null,
        onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancel()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            placeholder: "登録コード",
            value: _ctx.editData.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editData.value) = $event))
          }, null, 8, ["value"]),
          _createVNode(_component_a_input, {
            placeholder: "場所名",
            value: _ctx.editData.point,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editData.point) = $event))
          }, null, 8, ["value"]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.Ok,
            loading: _ctx.loading,
            disabled: _ctx.editData.id==0
          }, {
            default: _withCtx(() => [
              _createTextVNode("登録")
            ]),
            _: 1
          }, 8, ["onClick", "loading", "disabled"]),
          _createVNode(_component_a_button, {
            type: "primary",
            danger: "",
            onClick: _ctx.Delete,
            loading: _ctx.loading,
            style: {"float":"right"},
            disabled: _ctx.editData.id==0
          }, {
            default: _withCtx(() => [
              _createTextVNode("削除")
            ]),
            _: 1
          }, 8, ["onClick", "loading", "disabled"])
        ]),
        _: 1
      }, 8, ["open"]),
      _createVNode(_component_a_modal, {
        title: "一括削除",
        open: _ctx.bulkvisible,
        footer: null,
        "ok-text": "一括削除",
        onOk: _cache[4] || (_cache[4] = ($event: any) => (_ctx.bulk?_ctx.BulkDelete:null)),
        okType: "danger",
        onCancel: _cache[5] || (_cache[5] = ()=>{_ctx.bulkvisible=false})
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 削除するQRコードの１文字目を入力してください "),
          _createVNode(_component_a_input, {
            value: _ctx.bulk,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bulk) = $event)),
            maxlength: "1"
          }, null, 8, ["value"]),
          _createVNode(_component_a_button, {
            type: "primary",
            danger: "",
            onClick: _ctx.BulkDelete,
            loading: _ctx.loading,
            style: {"float":"right","margin-top":"5px"},
            disabled: !_ctx.bulk
          }, {
            default: _withCtx(() => [
              _createTextVNode("一括削除")
            ]),
            _: 1
          }, 8, ["onClick", "loading", "disabled"]),
          _hoisted_3
        ]),
        _: 1
      }, 8, ["open"])
    ])
  ], 64))
}